import React from 'react';

export const BalconyIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5382_44248)">
          <path
            d="M4.67578 15.1071V9.15896C4.67578 3.73242 5.67493 3.73242 11.9747 3.73242C18.2744 3.73242 19.2736 3.73242 19.2736 9.14981V14.9424"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9746 3.85156V15.1073"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.87248 13.7159C2.98004 13.7159 3.06723 13.6216 3.06723 13.5054C3.06723 13.3892 2.98004 13.2949 2.87248 13.2949C2.76493 13.2949 2.67773 13.3892 2.67773 13.5054C2.67773 13.6216 2.76493 13.7159 2.87248 13.7159Z"
            fill={fill}
            stroke={fill}
            strokeMiterlimit="10"
          />
          <path
            d="M2.87242 13.5059C2.85548 15.757 2.84701 18.0081 2.83008 20.2593L2.87242 13.5059Z"
            fill={fill}
          />
          <path
            d="M2.87242 13.5059C2.85548 15.757 2.84701 18.0081 2.83008 20.2593"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.51311 13.7061C6.62067 13.7061 6.70786 13.6119 6.70786 13.4956C6.70786 13.3794 6.62067 13.2852 6.51311 13.2852C6.40555 13.2852 6.31836 13.3794 6.31836 13.4956C6.31836 13.6119 6.40555 13.7061 6.51311 13.7061Z"
            fill={fill}
            stroke={fill}
            strokeMiterlimit="10"
          />
          <path
            d="M6.51304 13.4961C6.49611 15.7472 6.48764 17.9984 6.4707 20.2495L6.51304 13.4961Z"
            fill={fill}
          />
          <path
            d="M6.51304 13.4961C6.49611 15.7472 6.48764 17.9984 6.4707 20.2495"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.1547 13.6983C10.2623 13.6983 10.3495 13.6041 10.3495 13.4878C10.3495 13.3716 10.2623 13.2773 10.1547 13.2773C10.0472 13.2773 9.95996 13.3716 9.95996 13.4878C9.95996 13.6041 10.0472 13.6983 10.1547 13.6983Z"
            fill={fill}
            stroke={fill}
            strokeMiterlimit="10"
          />
          <path
            d="M10.1546 13.4883C10.1377 15.7394 10.1292 17.9906 10.1123 20.2417L10.1546 13.4883Z"
            fill={fill}
          />
          <path
            d="M10.1546 13.4883C10.1377 15.7394 10.1292 17.9906 10.1123 20.2417"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.8041 13.6885C13.9117 13.6885 13.9989 13.5943 13.9989 13.4781C13.9989 13.3618 13.9117 13.2676 13.8041 13.2676C13.6966 13.2676 13.6094 13.3618 13.6094 13.4781C13.6094 13.5943 13.6966 13.6885 13.8041 13.6885Z"
            fill={fill}
            stroke={fill}
            strokeMiterlimit="10"
          />
          <path
            d="M13.8041 13.4785C13.7871 15.7297 13.7787 17.9808 13.7617 20.2319L13.8041 13.4785Z"
            fill={fill}
          />
          <path
            d="M13.8041 13.4785C13.7871 15.7297 13.7787 17.9808 13.7617 20.2319"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.4447 13.7159C17.5523 13.7159 17.6395 13.6216 17.6395 13.5054C17.6395 13.3892 17.5523 13.2949 17.4447 13.2949C17.3372 13.2949 17.25 13.3892 17.25 13.5054C17.25 13.6216 17.3372 13.7159 17.4447 13.7159Z"
            fill={fill}
            stroke={fill}
            strokeMiterlimit="10"
          />
          <path
            d="M17.4447 13.5059C17.4277 15.757 17.4193 18.0081 17.4023 20.2593L17.4447 13.5059Z"
            fill={fill}
          />
          <path
            d="M17.4447 13.5059C17.4277 15.757 17.4193 18.0081 17.4023 20.2593"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.1283 13.7061C21.2359 13.7061 21.3231 13.6119 21.3231 13.4956C21.3231 13.3794 21.2359 13.2852 21.1283 13.2852C21.0208 13.2852 20.9336 13.3794 20.9336 13.4956C20.9336 13.6119 21.0208 13.7061 21.1283 13.7061Z"
            fill={fill}
            stroke={fill}
            strokeMiterlimit="10"
          />
          <path
            d="M21.1283 13.4961C21.1113 15.7472 21.1029 17.9984 21.0859 20.2495L21.1283 13.4961Z"
            fill={fill}
          />
          <path
            d="M21.1283 13.4961C21.1113 15.7472 21.1029 17.9984 21.0859 20.2495"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.0854 15.5742H2.87207"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.0854 20.2676H2.87207"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5382_44248">
            <rect
              width="20"
              height="18"
              fill="white"
              transform="translate(2 3)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
